import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { EntryCashOutControls } from '@/components/entry-card';
import type { EntryCashOutControlsProps } from '@/components/entry-card';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

type BetDetailCashOutFooterProps = {
    controls: EntryCashOutControlsProps;
};

/** Sticky bottom dock hosting the staged cash-out controls on the entry detail screen (SBK-2444). */
export const BetDetailCashOutFooter = ({ controls }: BetDetailCashOutFooterProps) => {
    const insets = useSafeAreaInsets();
    return (
        <Box
            position="absolute"
            bottom={0}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            paddingTop="s16"
            paddingHorizontal="s16"
            style={[common.full, common.zIndex1, { paddingBottom: insets.bottom + 16 }]}
        >
            <EntryCashOutControls {...controls} variant="detail" />
        </Box>
    );
};
